import { getLawyerContactSchema } from "./lawyerContactSchema";
import { api } from "../utils/api";
import { executeRecaptcha } from "../utils/recaptcha";

export const initLawyerContactForm = () => {
  // Sayfadaki tüm avukata sor formlarını başlatır.
  const containers = document.querySelectorAll<HTMLElement>(
    ".js-lawyer-contact-form",
  );
  const translations =
    (window as any).commonVariables?.translations?.sidebarContact?.form || {};

  if (containers.length === 0) return;

  containers.forEach((container) => {
    const form = container.querySelector<HTMLFormElement>(".sidebar-form");
    if (!form) return;

    const fieldset = form.querySelector("fieldset");
    const submitBtn = form.querySelector<HTMLButtonElement>(
      ".sidebar-form__submit",
    );
    const errorAlert = form.querySelector<HTMLElement>(
      ".sidebar-form__alert--error",
    );
    const originalBtnHTML = submitBtn?.innerHTML || "";

    const clearErrors = () => {
      form
        .querySelectorAll(".sidebar-form__input")
        .forEach((el) => {
          el.classList.remove("has-error");
          el.removeAttribute("aria-invalid");
        });
      form
        .querySelectorAll(".sidebar-form__error")
        .forEach((el) => (el.textContent = ""));
      if (errorAlert) {
        errorAlert.style.display = "none";
        errorAlert.innerHTML = "";
      }
    };

    const setFieldError = (fieldName: string, message: string) => {
      const input = form.querySelector(`[name="${fieldName}"]`);
      const errorDiv = input
        ?.closest(".sidebar-form__field")
        ?.querySelector(".sidebar-form__error");
      if (input && errorDiv) {
        input.classList.add("has-error");
        input.setAttribute("aria-invalid", "true");
        errorDiv.textContent = message;
      }
    };

    const renderSuccessState = () => `
      <div class="cf-success-state">
        <div class="cf-success-state__icon">
          <svg class="icon icon--stroke-thick"><use xlink:href="#icon-check"></use></svg>
        </div>
        <h3 class="cf-success-state__title">${translations.successTitle || "Teşekkürler!"}</h3>
        <p class="cf-success-state__message">${translations.successMessage || "Mesajınız alındı."}</p>
      </div>
    `;

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      clearErrors();

      const formData = new FormData(form);
      const rawData = Object.fromEntries(formData.entries());

      const result = getLawyerContactSchema().safeParse(rawData);

      if (!result.success) {
        result.error.flatten().formErrors.forEach((msg) => {
          if (errorAlert) {
            errorAlert.style.display = "block";
            errorAlert.innerHTML += `<span>${msg}</span>`;
          }
        });
        Object.entries(result.error.flatten().fieldErrors).forEach(
          ([field, msgs]) => {
            if (msgs) setFieldError(field, msgs[0]);
          },
        );
        return;
      }

      if (fieldset) fieldset.disabled = true;
      if (submitBtn)
        submitBtn.innerHTML = `<span>${translations.sending || "Gönderiliyor..."}</span>`;

      try {
        const recaptchaToken = await executeRecaptcha("contact_form");

        const payload = {
          ...result.data,
          recaptcha_token: recaptchaToken,
        };

        await api.post("/forms/sidebar", payload);

        container.innerHTML = renderSuccessState();

        if (typeof (window as any).gtag === "function") {
          (window as any).gtag("event", "generate_lead", {
            form_type: rawData.source || "Lawyer Contact Form",
          });
        }
      } catch (err: any) {
        if (fieldset) fieldset.disabled = false;
        if (submitBtn) submitBtn.innerHTML = originalBtnHTML;

        if (errorAlert) {
          errorAlert.style.display = "flex";
          errorAlert.innerHTML = `<span>${err.message || translations.errorGeneral || "Error"}</span>`;
        }
      }
    });
  });
};
